import styled from 'styled-components';

export const ContainerRejectedBy = styled.div`
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
`;

export const TextStatusRejectedProject = styled.p`
  text-transform: uppercase;
  margin-right: 5px;
`;

export const RejectedBy = styled.span`
  color: #FF5555;
  font-weight: 500;
`;
